import kebabCase from 'lodash-es/kebabCase';

export function getSpecialSlug(specialTitle: string): string {
  const slug = kebabCase(specialTitle.replace(/[^a-zA-Z0-9\s]/g, '').trim());
  // since we're trimming out non-alphanumeric characters, we need to make sure we don't end up with an empty string
  return slug || 'special';
}
